import React from 'react';
import { UserRoundIcon, LibraryIcon, FileTextIcon } from 'lucide-react';
import { Section, SectionHeading } from '../Section';
import { Reveal } from '../Reveal';
import { LinkButton } from '../Button';
const steps = [{
  icon: UserRoundIcon,
  title: 'Your dedicated adviser, locally',
  body: 'One adviser in your city who meets your family in person, understands the business, and stays with you for years — not a call centre that reassigns you each quarter. In Bengaluru and Chennai, that is the founder himself.'
}, {
  icon: LibraryIcon,
  title: 'Backed by a central research desk',
  body: 'Behind that adviser sits the Bengaluru desk — the house view, the model portfolios, and a written due-diligence process that decides what is allowed on the approved shelf every office works from.'
}, {
  icon: FileTextIcon,
  title: 'Transparent consolidated reporting',
  body: 'One statement across every family member, entity and asset class — post-tax returns, with our fee shown in rupees. Nothing embedded, nothing hidden.'
}];
export function HowItWorks() {
  return <Section tone="paper" ariaLabel="How it works" data-id="element-80" data-mp="1q35nsep2c0yn">
      <SectionHeading eyebrow="How it works" title="Three things have to be true for advice to be worth taking." description="Our hub-and-spoke model exists so that none of them depend on where your family happens to live." data-id="element-81" data-mp="1q0jjcnxgy1kn" />

      <ol className="relative mt-14 grid gap-10 md:grid-cols-3 md:gap-8" data-id="element-82" data-mp="1c3e5i1rijyeu">
        <div aria-hidden="true" className="absolute left-0 right-0 top-[1.4rem] hidden h-px bg-line md:block" data-id="element-83" data-mp="1741hhdowolao" />
        {steps.map((step, index) => <Reveal as="li" key={step.title} delay={index * 0.06} className="relative" data-id="element-84" data-mp="1g46gp0jy4ddr" data-mpi={index}>
            <div className="flex items-center gap-3" data-id="element-85" data-mp="1g6j59wk7llzs">
              <span className="relative z-10 flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-gold/40 bg-cream" data-id="element-86" data-mp="2wh519uuqsudh">
                <step.icon className="h-[1.1rem] w-[1.1rem] text-gold-dark" aria-hidden="true" data-id="element-87" data-mp="2rlpn11stowgj" />
              </span>
              <span className="font-sans text-overline font-semibold uppercase text-charcoal-400" data-id="element-88" data-mp="1u4s1nhndbkle">
                Step {index + 1}
              </span>
            </div>
            <h3 className="mt-5 font-serif text-h3 text-charcoal" data-id="element-89" data-mp="1y4ix3ynuaow9">{step.title}</h3>
            <p className="mt-3 text-[0.95rem] leading-relaxed text-charcoal-600" data-id="element-90" data-mp="2356q2pvmpft4">{step.body}</p>
          </Reveal>)}
      </ol>

      <Reveal className="mt-12" data-id="element-91" data-mp="1ah12zwh3req4">
        <LinkButton to="/approach" variant="quiet" data-id="element-92" data-mp="1ai2q4zbe7ro7">
          Read the full philosophy →
        </LinkButton>
      </Reveal>
    </Section>;
}